import Analytics from '@jetshop/core/analytics/Analytics';
import { trackCartCheckout } from '@jetshop/core/analytics/tracking';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import CartProvider from '@jetshop/core/components/Query/CartProvider';
import t from '@jetshop/intl';
import Image from '@jetshop/ui/Image/Image';
import { Price } from '@jetshop/ui/Price';
import theme from '@jetshop/ui/utils/theme';
import React from 'react';
import styled from 'react-emotion';
import { ReactComponent as Cross } from '../../../svg/Cross.svg';
import Button from '../../ui/Button';
import cartQuery from '../../Cart/CartQuery.gql';

const Container = styled('aside')`
  ${theme('above.sm')} {
    width: 320px;
  }
  ${theme('below.sm')} {
    width: 100%;
  }
  background-color: ${theme('colors.white')};
`;

const CheckoutButton = styled(Button)`
  padding: ${theme('space.2')};
  margin: ${theme('space.1')};
  text-align: center;
  background: ${({ theme }) => theme.colors.blue};
`.withComponent('a');

const ProductImageWrapper = styled('div')`
  width: 5rem;
  margin-right: 1rem;
`;

const ProductCheckoutContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  a {
    text-decoration: none;
    :hover {
      opacity: 0.8;
      text-decoration: none;
      color: white;
    }
  }
`;

const Product = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: ${theme('space.2')};
`;

const ProductDetails = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  color: black;
`;

const CloseButton = styled('button')`
  svg {
    width: 1em;
    height: 1em;
    use {
      fill: #000000;
    }
  }
`;

const Header = styled('h3')`
  font-family: ${theme('fontFamilies.heavy')};
  font-size: ${theme('fontSizes.2')};
  margin-bottom: ${theme('space.1')};
`;

const ProductName = styled('p')`
  font-size: ${theme('fontSizes.0')};
`;

const ProductToast = ({ product, cart, closeToast, selectedVariation }) => {
  const pricing = selectedVariation || product;
  return (
    <Container>
      <ProductCheckoutContainer>
        <Product>
          {product.images.length > 0 && (
            <ProductImageWrapper>
              <Image
                src={product.images[0].url}
                sizes={80}
                aspect={'1:1'}
                alt={product.images[0].alt}
              />
            </ProductImageWrapper>
          )}
          <ProductDetails>
            <Header>{t('Added to bag')}</Header>
            <ProductName>{product.name}</ProductName>
            <Price
              price={pricing.price}
              recommendedPrice={pricing.recommendedPrice}
              previousPrice={pricing.previousPrice}
            />
          </ProductDetails>
          <CloseButton onClick={closeToast}>
            <Cross />
          </CloseButton>
        </Product>
        {cart && cart.externalCheckoutUrl && (
          <ChannelContext.Consumer>
            {({ selectedChannel }) => (
              <Analytics>
                {track => (
                  <CheckoutButton
                    href={`${cart.externalCheckoutUrl}&channelCountry=${
                      selectedChannel.country.code
                    }`}
                    onClick={() => {
                      track(trackCartCheckout({ cart }));
                    }}
                  >
                    {t('To checkout')}
                  </CheckoutButton>
                )}
              </Analytics>
            )}
          </ChannelContext.Consumer>
        )}
      </ProductCheckoutContainer>
    </Container>
  );
};
const ProductToastWrapper = props => (
  <CartProvider query={cartQuery}>
    {({ data }) => <ProductToast {...props} cart={data && data.cart} />}
  </CartProvider>
);

export default ProductToastWrapper;
